// extracted by mini-css-extract-plugin
export default {"root":"rotations_root__9jtHf","loading":"rotations_loading__3O3By"};